export const en = {
	'common.remove': 'Remove',
	'common.customizableContent': 'Customizable content',
	'common.backToBookings': 'Back to Bookings',
	'common.backToServiceSettings': 'Back to Service settings',
	'common.backToCustomizableContent': 'Back to customizable content',
	'common.cancel': 'Cancel',
	'common.clear': 'Clear',
	'common.all': 'All',
	'common.back': 'Back',
	'common.add': 'Add',
	'common.menu': 'Menu',
	'common.done': 'Done',
	'common.save': 'Save',
	'common.edit': 'Edit',
	'common.delete': 'Delete',
	'common.logOut': 'Log Out',
	'common.login': 'Login',
	'common.hello': 'Hello',
	'common.errors': 'Errors',
	'common.savingError': 'Saving error',
	'common.saveChanges': 'Save changes',
	'common.notAvailable': 'Not available yet',
	'common.language.finnish': 'Finnish',
	'common.language.english': 'English',
	'common.language.swedish': 'Swedish',
	'common.username': 'Username',
	'common.password': 'Password',
	'common.email': 'Email',
	'common.errors.105': 'SSN is not valid',
	'common.errors.601': 'The admin user does not exist',
	'common.errors.602': "You don't have enough rights to reset user password",
	'common.errors.801': 'The link for setting a password is expired',
	'common.errors.802':
		'Password is not strong enough, it needs to include small and big letters and digits',
	'common.errors.422':
		'Selected expert appointment timeslot is already booked, see other booked timeslots on the same day',
	'common.errors.423': 'Timeslot needs to be in the future',
	'common.errors.1007': 'Queue creation failed',
	'common.errors.1006': 'Expert is missing ninchat id',
	'common.errors.1005': 'Failed to create a ninchat meeting',
	'common.errors.1004': 'Failed to add expert to ninchat meeting',
	'common.errors.1001': 'Creating a user to ninchat failed',
	'common.errors.1002': 'Adding an expert to the ninchat organization failed',
	'common.errors.1003':
		'Email address is already in use, and not able to attach to existing user',
	'common.errors.1100': 'Email address already in use',
	'header.serviceSettings': 'Service settings',
	'header.chat': 'Chat',
	'header.chatCodes': 'Chat codes',
	'header.experts': 'Experts',
	'header.bookings': 'Bookings',
	'header.userManagement': 'User management',
	'header.asyncMessaging': 'Messages',
	'header.asyncMessaging.messagingCategories': 'Message categories',
	'header.asyncMessaging.messageCodes': 'Message codes',
	'mainMenu.options.global': 'Global',
	'mainMenu.options.globalGeneralSettings': 'Global settings',
	'mainMenu.options.globalUserManagement': 'Global user management',
	'mainMenu.options.organizationUserSettings': 'User management',
	'mainMenu.options.serviceSettings': 'Service settings',
	'mainMenu.options.chat': 'Chat',
	'mainMenu.options.general': 'General',
	'mainMenu.options.bookingAppointments': 'Bookings',
	'mainMenu.options.experts': 'Experts',
	'mainMenu.options.newOrganization': 'New organization',
	'mainMenu.options.announcements': 'Announcements',
	'mainMenu.options.termsOfService': 'Terms of service',
	'mainMenu.options.surveys': 'Surveys',
	'mainMenu.options.messages': 'Messages',

	'login.headline': 'Admin Panel Login',
	'login.loginFailed': 'Login failed.',
	'login.fromRegistration.title':
		'You have successfully created password. Login to continue.',
	'login.changePassword': 'Forgot password?',
	'login.logout.expired':
		'Your session expired and you have been automatically logged out, please log in again if you need to use the admin panel, thank you.',
	'changePassword.headline': 'Admin Panel Change Password',
	'changePassword.successText':
		'An email has been succesfully sent to the address that was provided',
	'changePassword.subtext':
		'An email will be sent to this address with a link to change your password. This link will expire after 30 minutes it was sent.',
	'changePassword.submit': 'Change Password',
	'changePassword.backToLogin': 'Back To Login',
	'changePassword.error.incorrectFormat': 'Incorrect email format',
	'changePassword.error.general': 'There was an error with the request',
	'changePassword.error.badEmail': 'Email was not found',
	'chatCodes.headline': 'Chat Codes',
	'chatCodes.headline.messageCodes': 'Message codes',
	'chatCodes.description':
		'View and manage the white label configuration of the client. Please note that changes made may require a new push to development environment by the maintenance team in order to be visible.',
	'chatCodes.listOfCodes': 'List of codes',
	'chatCodes.button.addNew': 'New codes',
	'chatCodes.table.codeGroupName': 'Code Group Name',
	'chatCodes.table.assignedTo': 'Assigned to',
	'chatCodes.table.codes': 'Codes',
	'chatCodes.table.availability': 'Availability',
	'chatCodes.table.actions': 'Actions',
	'chatCodes.table.subcategory': 'Sub-category',
	'chatCodes.button.file': 'File',
	'chatCodes.button.duplicate': 'Duplicate',
	'chatCodes.deleteConfirmation': 'Are you sure you want to delete chatCode?',
	'chatCodesModal.title.add': 'New codes',
	'chatCodesModal.title.edit': 'Edit codes',
	'chatCodesModal.fields.codeGroupName': 'Code Group Name',
	'chatCodesModal.fields.assignedService': 'Assigned service',
	'chatCodesModal.fields.amountOfCodes': 'Amount of codes in total',
	'chatCodesModal.fields.amountOfUses': 'Amount of uses per code',
	'chatCodesModal.fields.startingDate': 'Starting date',
	'chatCodesModal.fields.today': 'Today',
	'chatCodesModal.fields.expirationDate': 'Expiration date',
	'chatCodesModal.fields.endOfYear': 'End of year',
	'chatCodesModal.fields.6monthsFromNow': '6 months from now',
	'chatCodesModal.fields.1yearFromNow': '1 year from now',
	'chatCodesModal.fields.noExpirationDate': 'No expiration date',
	'chatCodesModal.fields.subcategory': 'Sub-category',
	'chatCodesModal.validation.codeGroupName': 'code group name cannot be empty',
	'chatCodesModal.validation.assignedService': 'assign service to chat code',
	'chatCodesModal.validation.assignedSubcategory':
		'assign subcategory to message code',
	'chatCodesModal.validation.codesTotal':
		'total codes need to be larger than 0',
	'chatCodesModal.validation.startingDate': 'put correct starting date',
	'chatCodesModal.validation.expirationDate': 'put correct expiration date',
	'chatCodesModal.validation.expirationDate.past': 'cannot select a past date',
	'empty.headline': 'Organization not selected',
	'empty.description':
		'Select organization first to be able to edit service settings and chat codes.',
	'organizationSettings.serviceSettings.title': 'Service Settings',
	'organizationSettings.serviceSettings.description':
		'View and manage the white label configuration of the client. Please note that changes made may require a new push to development environment by the maintenance team in order to be visible.',
	'organizationSettings.serviceSettings.serviceModules.title':
		'Service modules',
	'organizationSettings.serviceSettings.organizationInformation.title':
		'Organization information',
	'organizationSettings.serviceSettings.interface.title': 'Brand & Interface',
	'organizationSettings.serviceSettings.serviceUrl.title':
		'Service URL address',
	'organizationSettings.serviceSettings.privacyStatement.title':
		'Privacy statement',
	'organizationSettings.serviceSettings.navigation.organization':
		'Organization',
	'organizationSettings.serviceSettings.navigation.siteSettings':
		'Site settings',
	'organizationSettings.serviceSettings.navigation.services': 'Services',
	'organizationSettings.serviceSettings.navigation.serviceArea': 'Service area',
	'organizationSettings.serviceSettings.navigation.customizableContent':
		'Customizable content',
	'organizationSettings.serviceInformationPage.title':
		'Service information page',
	'organizationSettings.serviceInformationPage.body':
		'All users will see this page when entering the service for the first time. It is also accessible from the menu, and should contain at least the following information: What the service is about, who is the producer of this service and what is the client’s billing policy.',
	'organizationSettings.chatCodesInformationPage.title':
		'Chat codes information',
	'organizationSettings.chatCodesInformationPage.body':
		'An additional information regarding specifically the chat codes, attached to service information page when accessed from the menu. Editing this page is not recommended.',
	'organizationSettings.languageInfo':
		'Make sure to modify all language versions if needed. You can select the language you want to modify above.',
	'organizationSettings.endOfService.title': 'Thank you and redirection page',
	'organizationSettings.endOfService.body':
		'This screen is shown after the user has completed their chat experience and has given feedback. This page should contain information about what happens next and give the user options as to how they can continue on their healthcare path inside the client’s service offering. In addition, the user should be given the option to find their nearest pharmacies and to go to OmaKanta.',
	'organizationSettings.thankYou.redirectionLinks.title':
		'Redirection links (Section 1)',
	'organizationSettings.thankYou.redirectionLinksSecond.title':
		'Redirection links (Section 2)',
	'organizationSettings.thankYou.redirectionLinks.button': 'New link',
	'organizationSettings.thankYou.headline': 'Thank you page and redirection',
	'organizationSettings.thankYou.informationText.title': 'Information text',
	'organizationSettings.thankYou.redirectionLinks.textfield.title':
		'Section 1 headline',
	'organizationSettings.thankYou.redirectionLinksSecond.textfield.title':
		'Section 2 headline',
	'organizationSettings.thankYou.redirectionButtons.title':
		'Redirection buttons',
	'organizationSettings.thankYou.redirectionButtons.body':
		'You can modify and create new redirection buttons to your thank you page. These should be the primary actions that you want your users to take after having used the service. Do not overcrowd your page with buttons, instead primarily use links in the redirection links sections. Select your primary button to be the most likely action that you users are to take.',
	'organizationSettings.thankYou.redirectionButtonsTitle':
		'Buttons (select 0-2)',
	'organizationSettings.thankYou.buttons.logOut': 'Log out',
	'organizationSettings.thankYou.buttons.backToServiceSelection':
		'Back to Service Selection',
	'organizationSettings.thankYou.buttons.custom': 'Custom button',
	'organizationSettings.thankYou.buttons.create': 'Create custom button',
	'organizationSettings.thankYou.primaryButton.title': 'Primary button',
	'organizationSettings.thankYou.newButtonModal.title': 'Custom button',
	'organizationSettings.thankYou.newButtonModal.linkText.headline':
		'Button text',
	'organizationSettings.thankYou.newButtonModal.linkUrl.headline': 'Button url',
	'organizationSettings.customizableContent.customizableContents.title':
		'Customizable contents',
	'organizationSettings.customizableContent.emailTemplates.title':
		'Email templates',
	'organizationSettings.preQuestionnaire.title': 'Pre-questionnaire form',
	'changeOrganizationModal.addNewOrganization': 'Add new organization',
	'changeOrganizationModal.title': 'Change organization',
	'changeOrganizationModal.fields.organization.label': 'Organization',
	'newOrganizationModal.title': 'New organization',
	'newOrganisationModal.subheader.general.info': 'General information',
	'newOrganizationModal.create': 'Create organization',
	'organization.fields.organizationInfo': 'Organization Info',
	'organization.fields.primaryColor':
		'Primary color HEX (used for headings, buttons)',
	'organization.fields.primaryColor.placeholder': 'For example #FF5733',
	'organization.fields.secondaryColor': 'Secondary color HEX',
	'organization.fields.secondaryColor.placeholder': 'For example #FF5733',
	'organization.fields.logo': 'Logo',
	'organization.fields.logo.placeholder': 'Select a file',
	'organization.fields.logoInfoText':
		'Logo files have to be 256 pixels wide and 128 pixels high(256x128px)',
	'organization.fields.contactEmail': 'Contact person email',
	'organization.fields.contactPerson': 'Contact person',
	'organization.fields.paymentNumber': 'Payment Number',
	'organization.fields.organizationName': 'Organization name',
	'organization.fields.clientId': 'Client ID(auto-generated)',
	'organization.fields.background': 'Background',
	'organization.fields.background.placeholder': 'Select a file',
	'organization.fields.backgroundInfoText':
		'Background files should be either vector files (PDF, SVG) or images (PNG) the size of 1900x1080 pixels in order to function properly.',
	'organization.fields.privacyStatementTitle':
		'Privacy Statement Title ({{lang}})',
	'organization.fields.privacyStatementUrl': 'Privacy Statement URL ({{lang}})',
	'organization.fields.serviceModules.title': 'Service modules',
	'organization.fields.serviceModules.checkbox.booked': 'Main page bookings',
	'organization.fields.serviceModules.checkbox.acting': 'Acting on behalf',
	'organization.fields.serviceModules.checkbox.logout': 'Separate log out',
	'organization.fields.serviceModules.checkbox.contact': 'Contact form',
	'organization.fields.serviceModules.checkbox.yourBookings': 'My bookings',
	'organization.fields.serviceModules.checkbox.changeLocation':
		'Change my location',
	'organization.fields.serviceModules.checkbox.appointmentHistory':
		'Appointment history',
	'organization.fields.serviceModules.checkbox.remoteReception':
		'Main page remote reception',
	'organization.fields.serviceModules.checkbox.termsAndConditions':
		'Terms and conditions',
	'organization.fields.languageOptions.title': 'Language options',
	'organization.fields.country': 'Country',
	'organization.fields.type.internal': 'Internal organization',
	'organization.fields.type.external': 'External organization',
	'organization.fields.organizationVisibility.title':
		'Change my location settings',
	'organization.fields.organizationVisibility.dontShow':
		'Hide my organization from organization switchers',
	'organization.fields.serviceURLAddress': 'Service URL address',
	'organization.fields.serviceURLAddress.note':
		'Organisation spesific URL is determined based on the organisation name',
	'organization.validation.organizationName':
		'Organization Name cannot be empty',
	'organization.validation.contactPerson': 'Contact person cannot be empty',
	'organization.validation.contactPersonEmail': 'Incorrect email format',
	'organization.validation.logo': 'Logo cannot be empty',
	'organization.validation.hex': 'Put correct color hex value',
	'organization.validation.privacyStatementUrl':
		'Fill privacy statement url in {{language}}',
	'organization.validation.privacyStatementUrlText':
		'Fill privacy statement url text in {{language}}',
	'organization.validation.ninchatMasterKey': 'Put correct ninchat MasterKey',
	'organization.validation.ninchatSiteKey': 'Put correct ninchat SiteKey',
	'organization.validation.ninchatSecret': 'Put correct ninchat Secret',
	'organization.creation.success': 'Organization created',
	'newRedirectionLinkModal.title': 'Redirection link',
	'newRedirectionLinkModal.linkText.subtitle': 'Link text',
	'newRedirectionLinkModal.linkUrl.subtitle': 'Link URL',
	'newRedirectionLinkModal.error.linkFinnish': 'Put link text in finnish',
	'newRedirectionLinkModal.error.linkSwedish': 'Put link text in swedish',
	'newRedirectionLinkModal.error.linkEnglish': 'Put link text in english',
	'serviceInformationPageModal.title': 'Service Information Page',
	'endOfServiceModal.title': 'End of service and redirection',
	'endOfServiceModal.subtitle': 'Information text',
	'organizationServices.title': 'Services',
	'services.title': 'Services list',
	'services.addButton': 'New service',
	'services.additionalInfo.label':
		'Additional information for the services to experts',
	'services.info.codesUsed': 'Codes used',
	'services.info.noCodesAssigned': 'No code list assigned.',
	'services.icons.doctor': 'Doctor',
	'services.icons.nurse': 'Nurse',
	'services.icons.mentalwellbeing': 'Therapist',
	'services.icons.childhealth': 'Pediatrician',
	'services.icons.weight': 'Physiotherapist',
	'services.preQuestionnaire.title': 'Self-booking pre-questionnaire form',
	'services.preQuestionnaire.lead':
		'Set the questions for the questionnaire asked from all who complete a self-booking in the system.',
	'services.selfBookingConfirmation.title': 'Self-booking confirmation page',
	'services.selfBookingConfirmation.lead':
		'Set the content and redirection for the confirmation page of a successful self-booking.',
	'servicesForm.title': 'Service',
	'servicesForm.error.serviceNameFinnish': 'Put service name in finnish',
	'servicesForm.error.serviceNameSwedish': 'Put service name in swedish',
	'servicesForm.error.serviceNameEnglish': 'Put service name in english',
	'servicesForm.error.icon': 'Choose service icon',
	'servicesForm.error.chatqueueId': 'Put correct ninchat queue id',
	'servicesForm.serviceName.subtitle': 'Service Name',
	'servicesForm.field.icon': 'Service Icon',
	'servicesForm.serviceDescription.subtitle': 'Service description',
	'servicesForm.field.chatQueueId': 'Chat queue ID',
	'servicesForm.info.chatQueueId':
		'Copy and paste the desired chat queue ID from Ninchat to the field above.',
	'servicesForm.editService.title': 'Edit service',
	'servicesForm.addService.title': 'New service',
	'expertsModal.fields.ninchatId': 'Ninchat user id',
	'servicesForm.chatCodes.subtitle': 'Chat settings',
	'servicesForm.chatCodes.label': 'Requires code',
	'servicesForm.selfAssessment.checkbox.label':
		'Mandatory self-assessment form',
	'servicesForm.selfAssessmentOptional.checkbox.label':
		'Optional self-assessment form',
	'organization.fields.serviceModules.checkbox.htaConnector':
		'Self-assessment form',
	'organization.fields.serviceModules.checkbox.asyncMessaging':
		'Async Messaging',
	'areas.title': 'Service area',
	'areas.addButton': 'New area and/or postal code',
	'areas.subtitle': 'Include areas and postal codes',
	'areas.label.municipality': 'Municipality',
	'areas.label.postalCode': 'Postal code',
	'CreateAppointmentModal.title': 'Book an appointment',
	'CreateAppointmentModal.preQuestionnaire.title': 'Pre-questionnaire',
	'CreateAppointmentModal.error.ssn': 'Put proper social security number',
	'CreateAppointmentModal.error.expert': 'Choose expert from the list',
	'CreateAppointmentModal.error.startingDate': 'Put correct starting date',
	'CreateAppointmentModal.error.startingTime': 'Put correct starting time',
	'CreateAppointmentModal.error.startingDate.past': 'Cannot select a past date',
	'CreateAppointmentModal.header.participants': 'Participants',
	'CreateAppointmentModal.error.nationality': 'Select nationality',
	'CreateAppointmentModal.error.groupAttendee.name': 'Name is mandatory',
	'CreateAppointmentModal.error.groupAttendee.email': 'Enter valid email',
	'CreateAppointmentModal.error.groupAttendee.noExpert': 'Select an expert',
	'CreateAppointmentModal.error.groupAttendee.noNinchatId':
		'Expert is missing ninchat id',
	'CreateAppointmentModal.error.groupHost.noNinchatId':
		'Arranger is missing ninchat id',
	'CreateAppointmentModal.error.groupAttendee.duplicateExpert':
		'Expert allready added',
	'CreateAppointmentModal.error.groupAttendee.duplicatePatient':
		'Patient allready added',
	'CreateAppointmentModal.error.groupAttendee.duplicateGuest':
		'Guest allready added',
	'CreateAppointmentModal.error.timeslotsListEmpty':
		'Timeslots need to be generated first',
	'CreateAppointmentModal.error.availableDate': 'Date cannot be empty',
	'CreateAppointmentModal.error.availableAppointment':
		'Appointment cannot be empty',
	'CreateAppointmentModal.error.email': 'Put correct email address',
	'CreateAppointmentModal.field.ssn': 'Social security number',
	'CreateAppointmentModal.field.nationality': 'Patient nationality',
	'CreateAppointmentModal.field.expert': 'Expert',
	'CreateAppointmentModal.field.startingDate': 'Date',
	'CreateAppointmentModal.field.startingTime': 'Starting time',
	'CreateAppointmentModal.field.preferredEndingTime': 'Preferred ending time',
	'CreateAppointmentModal.field.otherDuration': 'Other',
	'CreateAppointmentModal.field.language': 'Patient language',
	'CreateAppointmentModal.field.email': 'Email',
	'CreateAppointmentModal.duration.subtitle': 'Duration (minutes)',
	'CreateAppointmentModal.duration.oneTimeslot.subtitle':
		'One timeslot duration(minutes)',
	'CreateAppointmentModal.generateTimeslots.text':
		'{{number}} timeslots will be generated. You will need to confirm the timeslots afterwards to open them.',
	'CreateAppointmentModal.generateTimeslots.button': 'Generate timeslots',
	'CreateAppointmentModal.timeslots.reservable': 'Reservable',
	'CreateAppointmentModal.timeslots.break': 'Break',
	'CreateAppointmentModal.timeslots.table.startingTime': 'Starting time',
	'CreateAppointmentModal.timeslots.table.endTime': 'End time',
	'CreateAppointmentModal.timeslots.table.type': 'Type',
	'CreateAppointmentModal.field.1on1': '1-on-1 appointment',
	'CreateAppointmentModal.field.group': 'Group appointment',
	'CreateAppointmentModal.field.patient': 'Patient',
	'CreateAppointmentModal.field.groupattendee.expert': 'Expert',
	'CreateAppointmentModal.field.guest': 'Guest',
	'CreateAppointmentModal.label.host': 'Organizer',
	'CreateAppointmentModal.field.name': 'Name',
	'CreateAppointmentModal.field.firstName': 'First name',
	'CreateAppointmentModal.field.lastName': 'Last name',
	'CreateAppointmentModal.field.guest.language': 'Attendee language',
	'CreateAppointmentModal.field.guest.language.finnish': 'Finnish',
	'CreateAppointmentModal.field.guest.language.english': 'English',
	'CreateAppointmentModal.field.guest.language.swedish': 'Swedish',
	'CreateAppointmentModal.header.addaparticipant': 'Add a participant',
	'CreateAppointmentModal.button.addparticipant': 'Add participant',
	'CreateAppointmentModal.reminderCheckbox':
		'Send a booking confirmation email to the patient',
	'createRemoteAppointment.emailReminder.lead':
		'Once registered, you and all parties involved will get a confirmation message of the registered appointment via email.',
	'CreateAppointmentModal.button.create': 'Register appointment',
	'CreateAppointmentModal.button.update': 'Update appointment',
	'CreateAppointmentModal.button.createOpenAppointment': 'Open timeslots',
	'CreateAppointmentModal.openAppointment.title': 'Open bookable timeslots',
	'CreateAppointmentModal.openAppointment.lead':
		'Once you have opened the time, patients can see and reserve it through the system.',
	'CreateAppointmentModal.groupvideo.checkbox': 'Groupvideo appointment',
	'CreateAppointmentModal.guest.name': 'Guest name',
	'CreateAppointmentModal.guest.email': 'Guest email',
	'CreateAppointmentModal.subtitle.open.new':
		'Select a date and how much you are going to work',
	'CreateAppointmentModal.subtitle.open.edit': 'Edit timeslot',
	'CreateAppointmentModal.subtitle.new.createNewTimeslotAndBookIt':
		'Create a new timeslot and book it',
	'CreateAppointmentModal.subtitle.new.bookAvailableTimeslot':
		'Book an available timeslot',
	'CreateAppointmentModal.subtitle.edit': 'Edit an appointment',
	'CreateAppointmentModal.field.date': 'Date',
	'CreateAppointmentModal.field.appointment': 'Appointment',
	'CreateAppointmentModal.button.nextAvailable': 'Next available',
	'CreateAppointmentModal.bookTimeslot.noMore':
		'No more available open timeslots',
	'CreateAppointmentModal.bookTimeslot.timeslotSectionTile': 'Timeslot',
	'CreateAppointmentModal.bookTimeslot.patientSectionTile': 'Patient',
	'CreateAppointmentModal.toast.1': 'New appointment created',
	'CreateAppointmentModal.toast.2': 'Appointment booked',
	'CreateAppointmentModal.toast.3': 'Appointment edited',
	'CreateAppointmentModal.toast.4': 'Open timeslots created',
	'CreateAppointmentModal.toast.5': 'Open timeslot edited',
	'bookings.title': 'Bookings',
	'bookings.subtitle': 'Browse all bookings',
	'bookings.lead.part1':
		'Open reservable times for booking, book new appointments and manage existing bookings.',
	'bookings.lead.part2':
		'Note that all bookings must be entered into the patient management system separately.',
	'bookings.table.patient.title': 'Patient (SSN)',
	'bookings.table.expert.title': 'Expert',
	'bookings.table.dateTime.title': 'Date, Time',
	'bookings.table.actions.title': 'Actions',
	'bookings.table.specialization.title': 'Spec.',
	'bookings.table.status.selfBooked': 'Reserved',
	'bookings.table.status.booked': 'Reserved',
	'bookings.table.status.cancelled': 'Cancelled',
	'bookings.table.status.open': 'Open',
	'bookings.table.status.title': 'Status',
	'bookings.button.create': 'Book an appointment',
	'bookings.button.create.groupvideo': 'Book an groupvideo appointment',
	'bookings.button.book': 'Book',
	'bookings.button.preQuestionnaire': 'Pre-questionnaire',
	'bookings.button.openAppointment': 'Open bookable timeslots',
	'bookings.filters.experts.label': 'Only show specific expert times',
	'bookings.filters.specialization.label': 'Only show specific specialization',
	'bookings.filters.openTimes.label': 'Show open times',
	'bookings.filters.bookedTimes.label': 'Show booked times',
	'bookings.filters.onlyFuture': 'Show upcoming times',
	'bookings.filters.startDate': 'Start Date',
	'bookings.filters.endDate': 'End Date',
	'bookings.filters.matchStartDate': 'Match to start date',
	'bookings.deleteConfirmation': 'Are you sure you want to delete appointment?',
	'bookings.table.group.multiple.patients': 'Multiple patients',
	'experts.title': 'Experts',
	'experts.lead':
		'View and manage experts working for the organization. Note that each expert has their own chat queue.',
	'experts.button.add': 'Add an expert',
	'experts.table.expertName': 'Name',
	'experts.table.specializations': 'Specializations',
	'experts.table.chatQueue': 'Queue id',
	'expert.table.ninhatId': 'Ninchat user',
	'experts.table.status': 'Status',
	'experts.table.actions': 'Actions',
	'experts.deleteConfirmation': 'Are you sure you want to delete expert?',
	'expertsModal.errors.firstName': 'First name cannot be empty',
	'expertsModal.errors.lastName': 'Last name cannot be empty',
	'expertsModal.errors.specializations': 'Put at least one specialization',
	'expertsModal.errors.chatQueueId': 'Put chat queue Id',
	'expertsModal.errors.email': 'Put correct email address',
	'expertsModal.title.edit': 'Edit an expert',
	'expertsModal.title.create': 'Add an expert',
	'expertsModal.fields.firstName': 'First name',
	'expertsModal.fields.lastName': 'Last name',
	'expertsModal.fields.specializations': 'Specializations / Titles',
	'expertsModal.fields.generateChatQueue':
		'Generate user automatically to Ninchat and add personal chat queue',
	'expertsModal.fields.chatQueueId': 'Chat queue Id',
	'expertsModal.fields.title.language': 'Language',
	'expertsModal.fields.title.communicationLanguage': 'Communication language',
	'expertsModal.fields.language.fi': 'Finnish',
	'expertsModal.fields.language.en': 'English',
	'expertsModal.fields.language.sv': 'Swedish',
	'expertsModal.toast.attachedNinchaUser':
		'User already has a Ninchat account, now account was added to be included in both systems.',
	'registration.title': 'Create account password',
	'registration.errors.samePassword':
		'Password and Confirm Password need to be the same',
	'registration.errors.validation':
		'Password need to have at least 12 characters including numbers, small and big letters',
	'registration.errors.general': 'Cannot set password. Contact administrator.',
	'registration.fields.password': 'Password',
	'registration.fields.passwordConfirm': 'Confirm password',
	'usersModal.actions.title': 'Actions',
	'usersModal.actions.status.title': 'Status',
	'usersModal.actions.actions.title': 'Actions',
	'usersModal.actions.buttons.resetPassword': 'Reset password',
	'usersModal.actions.buttons.lockUser': 'Lock user',
	'usersModal.actions.buttons.unlockUser': 'Unlock user',
	'usersModal.actions.buttons.logoutUser': 'Logout user',
	'usersModal.actions.buttons.actionLog': 'Download user action log',
	'usersModal.actions.error': 'Error. Action unsuccessfull.',
	'usersModal.actions.success': 'Action sucessfull.',
	'usersModal.validation.name': 'Put correct admin name',
	'usersModal.validation.lastName': 'Put correct admin last name',
	'usersModal.validation.firstName': 'Put correct admin first name',
	'usersModal.validation.email': 'Put correct email address',
	'usersModal.validation.organization': 'Select organization',
	'usersModal.edit.title': 'Edit user',
	'usersModal.add.title': 'Add user',
	'usersModal.fields.name': 'Name',
	'usersModal.fields.firstName': 'First name',
	'usersModal.fields.lastName': 'Last name',
	'usersModal.fields.email': 'User email address',
	'usersModal.fields.organization': 'Organization',
	'usersModal.fields.title.access': 'Access',
	'usersModal.fields.presets': 'Presets',
	'usersModal.fields.editingRights.title': 'Editing rights',
	'usersModal.fields.viewingRights.title': 'Viewing rights',
	'usersModal.fields.chatCode': 'Chat code',
	'usersModal.fields.experts': 'Experts',
	'usersModal.fields.bookings': 'Bookings',
	'usersModal.fields.users': 'Users',
	'usersModal.fields.serviceSettings': 'Service settings',
	'usersModal.buttons.add': 'Add user',
	'usersModal.buttons.edit': 'Edit user',
	'usersModal.confirmation.lockUser':
		'Are you sure you want to lock this user?',
	'usersModal.confirmation.unlockUser':
		'Are you sure you want to unlock this user?',
	'usersModal.confirmation.logoutUser':
		'Are you sure you want to logout this user?',
	'usersModal.confirmation.resetPassword':
		'Are you sure you want to reset password for this user?',
	'users.status.noPasswordSet': 'No password set',
	'users.status.notActive': 'User inactive',
	'users.status.active': 'User active',
	'users.presets.booker': 'Booker',
	'users.presets.organizationAdmin': 'Organization Admin',
	'users.presets.operationalAdmin': 'Operational Admin',
	'users.presets.custom': 'Custom',
	'users.toast.createUser':
		'New user created, the user will now receive an email confirmation and can set a password, the link is valid for 24 hours.',
	'users.toast.resetPassword':
		'Action successful, user has received an email for resetting password, reseting link is valid for 30 minutes.',
	'usersTable.confirmation.delete':
		'Are you sure you want to delete this user?',
	'usersTable.global.title': 'Global User Management',
	'usersTable.organization.title': 'Admins',
	'usersTable.lead':
		'Manage users. Here you can reset passwords, log users out, download their action logs in addition to managing access levels and creating new users.',
	'usersTable.buttons.add': 'Add a user',
	'usersTable.buttons.actions': 'Actions',
	'usersTable.columns.name': 'Name',
	'usersTable.columns.organization': 'Organization',
	'usersTable.columns.role': 'Role',
	'usersTable.columns.lastLogin': 'Last login',
	'usersTable.columns.status': 'Status',
	'usersTable.columns.actions': 'Actions',
	'questionnaireForm.title': 'Pre-questionnaire form',
	'questionnaireForm.lead':
		'Below you can find the patient’s answers to the pre-questionnaire.',
	'questionnaireForm.form.title': 'Pre-questionnaire form',
	'questionnaireForm.form.setQuestion': 'Set question',
	'questionnaireForm.form.mandatory': 'Mandatory',
	'questionnaireForm.form.addQuestion': 'Add a question',
	'selfBookingConfirmationModal.title': 'Self-booking confirmation page',
	'selfBookingConfirmationModal.additionalTest.subtitle':
		'Confirmation additional text',
	'selfBookingConfirmationModal.redirectionButton.subtitle':
		'Redirection button text',
	'selfBookingConfirmationModal.redirectionLink.subtitle': 'Redirection link',
	'datadeletion.fields.header': 'Data storing times',
	'datadeletion.fields.patientData': 'Patients',
	'datadeletion.fields.adminData': 'Admin users',
	'datadeletion.fields.expertData': 'Experts',
	'datadeletion.specifier.day': 'Days',
	'datadeletion.specifier.month': 'Months',
	'userManagement.title': 'User management',
	'userManagement.buttons.admins': 'Admins',
	'userManagement.buttons.experts': 'Experts',
	'userManagement.button.back': 'Back to user management',
	'userManagement.button.addEditExpert': 'Add / Edit an Expert',
	'userManagement.button.addEditAdmin': 'Add / Edit an Admin',

	'surveyItem.nameMissing': 'Survey name missing',
	'surveyItem.selectSurvey': 'Select a survey to add',
	'surveyItem.addSurvey': 'Add survey',
	'survey.Description':
		'When you register this appointment, you can choose to surveys to the patient. Surveys can include standardized medical surveys, or you can create your own from the ‘Survey tool’ tab.',
	'survey.Title': 'Surveys',

	'emailTemplates.title': 'E-mail templates',
	'emailTemplates.toast.saved': 'Template saved',
	'emailTemplates.toast.resetted': 'Template resetted to default',
	'emailTemplates.confirmModal.headline': 'Reset to defaults?',
	'emailTemplates.confirmModal.text':
		'Are you sure you want to reset the template to defaults? This action cannot be undone.',
	'emailTemplates.confirmModal.okButton': 'Reset to defaults',
	'emailTemplates.back': 'Back to E-mail templates',
	'emailTemplates.editor.title': 'Email template',
	'emailTemplates.editor.default': '(DEFAULT)',
	'emailTemplates.editor.custom': '(CUSTOM)',
	'emailTemplates.editor.content': 'Content',
	'emailTemplates.editor.showTagList': 'Show tags list',
	'emailTemplates.editor.explanation':
		'Use tags such as expert_name in your content texts for things that are case-specific, so that the user always gets the right information.',
	'emailTemplates.editor.tag': 'Tag',
	'emailTemplates.editor.description': 'Description',
	'emailTemplates.editor.actions': 'Actions',
	'emailTemplates.editor.copyTag': 'Copy Tag',
	'emailTemplates.editor.emailRichTextEditor': 'email',
	'emailTemplates.editor.resetButton': 'Reset to defaults',
	'emailTemplates.editor.previewtButton': 'Preview',
	'emailTemplates.editor.saveButton': 'Save template',
	'emailTemplates.editor.reset.toast': 'Resetting email template failed',
	'emailTemplates.editor.sender.name': 'Sender name',
	'emailTemplates.editor.sender.address': 'Sender address',
	'emailTemplates.editor.email.title': 'E-mail title',

	'organizationSelectionModal.button.login': 'Log in',
	'organizationSelectionModal.headline': 'Select an organization to log in to',
	'profileMenu.options.myInformation': 'My information',
	'profileMenu.options.changeOrganization': 'Change organization',
	'newOrganization.title': 'New Organization',
	'appointment.title.open.new': 'Open bookable timeslots',
	'appointment.title.open.edit': 'Edit bookable timeslot',
	'appointment.title.new': 'Book an appointment',
	'appointment.title.edit': 'Edit an appointment',
	'appointment.checkbox.bookAvailableTimeslot': 'Book an available timeslot',
	'appointment.checkbox.groupAppointment': 'Book a group appointment',
	'appointment.checkbox.createNewTimeslotAndBookIt':
		'Create a new timeslot and book it',
	'schedule.cancel.title': 'Cancel appointment?',
	'schedule.cancel.body':
		'Are you sure you want to cancel the appointment? This will send a notification to all participants.',
	'schedule.cancel.buttons.cancel': 'Cancel appointment',
	'schedule.cancel.buttons.close': 'Close without cancelling',

	'leaveChecker.title': 'Unsaved changes',
	'leaveChecker.description':
		'Are you sure you want to leave the page when you have unsaved changes?',
	'leaveChecker.submit': 'Leave',

	'asyncMessaging.categories.title': 'Message categories',
	'asyncMessaging.categories.lead':
		'Create message categories and assign expert to them',
	'asyncMessaging.categories.create': 'Create category',
	'asyncMessaging.subcategories': 'sub-categories',
	'asyncMessaging.newCategory.title': 'Category Name',
	'asyncMessaging.button.disableCategory': 'Disable category',
	'asyncMessaging.createCategory.form.subtitle.details': 'Details',
	'asyncMessaging.createCategory.form.fields.categoryName': 'Category name in',
	'asyncMessaging.createCategory.form.fields.open': 'Open',
	'asyncMessaging.createCategory.form.fields.open.more':
		'Anyone can send a message to this category',
	'asyncMessaging.createCategory.form.fields.restricted': 'Restricted',
	'asyncMessaging.createCategory.form.fields.restricted.more':
		'Message code is required to access this category',
	'asyncMessaging.subcategories.create': 'Add sub-category',
	'asyncMessaging.createCategory.form.validation.categoryName':
		'Put correct name in {{lang}}',
	'asyncMessaging.sendingError': 'Saving error. Please try again later.',
	'asyncMessaging.success': 'Saving success!',
	'asyncMessaging.newSubcategory.title': 'Sub-category name',
	'asyncMessaging.button.disableSubcategory': 'Disable sub-category',
	'asyncMessaging.disableCategory.confirmation':
		'Are you sure you want to disable this category?',
	'asyncMessaging.disableSubcategory.confirmation':
		'Are you sure you want to disable this sub-category?',
	'asyncMessaging.customizableContent.title': 'Async Messaging',
	'asyncMessaging.customizableContent.lead': 'Customizable content',
	'asyncMessaging.subcategories.title': 'Sub-categories',
	'asyncMessaging.customizableContent.messageFrontPage.title':
		'Message front page',
	'asyncMessaging.customizableContent.messageFrontPage.description':
		'Description text',
	'asyncMessaging.customizableContent.newMessageBanner.title':
		'New message view',
	'asyncMessaging.customizableContent.newMessagebanner.description':
		'Informative banner content',
	'asyncMessaging.experts.title': 'Experts',
	'asyncMessaging.experts.button.addExperts': 'Add experts',
	'asyncMessaging.newExperts.title': 'Add experts',
	'asyncMessaging.newExperts.searchBox.label':
		'Search by specialization or expert name',
	'asyncMessaging.newExperts.filters.all': 'All',
	'asyncMessaging.newExperts.filters.specializations': 'Specializations',
	'asyncMessaging.newExperts.filters.experts': 'Experts',
	'asyncMessaging.newExperts.searchAutocomplete.experts.label': 'Experts',
	'asyncMessaging.newExperts.searchAutocomplete.noExperts':
		'No matching experts',
	'asyncMessaging.subcategory.search.label':
		'Search for experts in this subcategory',
	'asyncMessaging.newExperts.specialization.filter.label':
		'Filter by specialization',
	'asyncMessaging.newExperts.specialization.filter.all': 'All specializations',
	'asyncMessaging.newExperts.addFilters':
		'Add a search term or filter to see results',
	'asyncMessaging.newExperts.selectAll': 'Select all',
	'asyncMessaging.newExperts.confirm': 'Confirm Selection',
	'asyncMessaging.newExperts.selectedExperts': 'Selected experts',
	'asyncMessaging.newExperts.noSelectedExperts':
		'You have not selected any experts',
	'asyncMessaging.newExperts.add': 'Add {{number}} experts',
};
